import React, { useState, useEffect } from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { Props } from "./ImageSet.interface"

export const ImageSet = ({
  oneX,
  twoX,
  alt,
  className,
  width,
  height,
}: Props) => {
  return (
    <LazyLoadImage
      className={className && className}
      srcSet={`${oneX} 1x, ${twoX} 2x`}
      src={oneX}      
      alt={alt || ""}
      width={width}
      height={height}      
      delayTime={500}
      visibleByDefault={false}
    />    
  )
}
